const styles = (theme) => ({
    errorwrap: {
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        fontSize: '0.7rem',
        justifyContent: 'space-between',
        width: '100%',
        background: 'white',
        padding: '100px',
        borderRadius: '5px',
        textAlign: 'center',
        height: "300px",
        color: "red"
    },
    wrap: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%'
    },
    contentWrapper: {
        padding: 0
    },
    section1: {
        width: '26%'
    },
    section2: {
        width: '72%'
    },
    heading: {
        padding: '20px 0 0px 15px',
        background: 'white',
        fontWeight: 'bold',
        fontSize: '14px'
    },
    profile: {
        width: '100%',
        height: '150',
    },
    category: {
        padding: '0 16px 16px',
        width: '100%'
    },
    cardContent: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'column'
    },
    statistics: {
        display: 'flex',
        flexWrap: 'wrap',
        marginTop: '10px'
    },
    profileDetails: {
        display: 'flex',
        flexDirection: 'column',
        padding: '0 16px 16px'
    },
    profileHeader: {
        padding: '16px'
    },
    item1: {
        display: 'flex',
        flexWrap: 'wrap',
        marginTop: '15px',
        '& > *': {
            margin: theme.spacing(0.5),
        },
    },
    item: {
        width: '32%',
        background: '#edf0f4',
        //padding: '10px',
        padding: '1rem 1rem 0.5rem 1rem',
        marginTop: '10px',
        marginRight: '1%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'baseline'
    },
    label: {
        color: 'lightgrey',
    },
    checkBoxLabel: {
        fontSize: '12px'
    },
    labelRoot: {
        marginBottom: '0'
    },
    value: {
        fontSize: '14px'
    },
    chips: {
        display: 'flex',
        justifyContent: 'space-between'
    }
});

export default styles;
